import PropTypes from 'prop-types'
import { Inline, SocialIcon, ListItem } from 'chaoskit/src/components'

const SocialGroup = ({ networks, ...rest }) => (
  <Inline {...rest}>
    {networks.map(({ service, url, title }) => (
      <ListItem key={service}>
        <SocialIcon
          css={{ willChange: 'transform' }}
          url={url}
          service={service}
          title={title}
        />
      </ListItem>
    ))}
  </Inline>
)

SocialGroup.propTypes = {
  networks: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.oneOf([
        'twitter',
        'facebook',
        'instagram',
        'youtube',
        'linkedin',
        'hacker-news',
        'rss',
      ]),
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
    })
  ).isRequired,
}

export default SocialGroup
